<template>
  <label :for="id">{{label}}</label>
  <VueMultiselect
    v-model="value"
    :options="options"
    :close-on-select="true"
    :clear-on-select="false"
    :placeholder="placeholder"
    :max-height="600"
    :id="id"
    label="name"
    track-by="name"
  >
  </VueMultiselect>
</template>

<script>
import VueMultiselect from "vue-multiselect";
// we are using this, just the @next version for vue 3
// https://vue-multiselect.js.org/
export default {
  components: {
    VueMultiselect,
  },
  props: {
    id: String,
    options: Array,
    label: String,
  },
  emits: ['change'],
  data(instance) {
    return {
      value: '',
      placeholder:
        instance.store[instance.store.currentCulture].dictionary.placeholderPickOrSearch,
      awaitingValue: null,
    };
  },
  mounted() {
    this.emitter.on("culture-change", () => {
      this.placeholder = this.store[this.store.currentCulture].dictionary.placeholderPickOrSearch;
    });
  },
  methods: {
      reset() {
          this.value = null;
      },
      setValueByName(name) {
          if(this.options.length)
            this.value = this.options.find(x => x.name.toLowerCase() === name.toLowerCase());
          else this.awaitingValue = name;
      } 
  },
  watch: {
    options() {
      if(this.awaitingValue)
        this.setValueByName(this.awaitingValue);
    }, 
    value() {
      this.$emit('change',this.value)
    }
  }
};
</script>
<style lang="postcss">
/* note not scoped as we are targeting all multiselects */
.multiselect {
  font-family: var(--font-it-ex);
  letter-spacing: 0.32px;
  margin-top: 10px;
  position: relative;
  &__content-wrapper {
    overflow:hidden;
    overflow-y: auto;
  }
  &__input {
    margin-bottom: 0 !important;
  }
  &__placeholder, &__single {
    border-bottom: 2px solid currentColor;
    display: block;
    line-height: 24px;
    padding: 0 10px 10px 0;
  }
  &__placeholder{
    opacity: 0.5;
  }
  ul {
    list-style: none;
    background: var(--color-grey-4);
    margin: 0;
    padding: 0;
    width: 100%;
    z-index: 3;
    li {
      color: var(--color-darkblue);
      transition: all var(--ani-speed-2) var(--ani-type-1);
      font-weight: var(--font-weight-regular);
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:before {
        background: currentColor;
        position: absolute;
        height: 1px;
        left: 0;
        right: 0;
        bottom: 1px;
        opacity: 0.5;
        content: "";
      }
      &:after {
        background: currentColor;
        position: absolute;
        height: 2px;
        left: 0;
        right: 0;
        bottom: 1px;
        content: "";
        transform: translateX(-101%);
        transition: transform var(--ani-speed-3) var(--ani-type-1),
          -webkit-transform var(--ani-speed-3) var(--ani-type-1);
      }

      &:hover {
          &:after{
            transform: translateX(0);
          }
        }
    }
  }

  &__option {
    width: 100%;
    display:block;
    margin: 0;
    padding: 0;
    padding: 10px 14px;
    &--highlight {
      background: var(--color-grey-3);
    }
  }

  &:after {
    content: '';
    position: absolute;
    width:24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg id='svg-arrow-down-small' width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15 1 L8 8 L1 1' stroke='%23000'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    top:6px;
    right: 0;
    transition: all ease 0.2s;
  }

  &--active:after {
    transform: rotate(180deg);
  }
}
</style>
